import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import { useAppWidthClass } from '../../../utils/hooks';

import { Welcome } from '../index.troy';

import gradient from '../../../assets/img/troy_standard-gradient_1080p.png';
import { WelcomeDescription, WelcomeTitle } from '../Welcome';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    background: `url(${gradient})`,
    backgroundSize: 'cover, cover'
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  wrapperDesktop: {
    width: '100%',
    margin: '16px 0',
    display: 'flex'
  },
  welcomeDesktop: {
    maxWidth: 624,
    justifyContent: 'center'
  },
  contentDesktop: {
    width: 310,
    marginLeft: 'auto'
  },
  wrapperTablet: {
    width: 310,
    margin: '24px 0 56px 0',
    display: 'flex',
    flexDirection: 'column'
  },
  contentTablet: {
    margin: '32px 0'
  },
  wrapperMobile: {
    width: 310,
    margin: '16px 0',
    maxWidth: '100%'
  }
}));

const LoginLayout = ({ children }) => {
  const classes = useStyles();
  const {
    widthClass,
    isDesktopWidth,
    isTabletWidth,
    isMobileWidth
  } = useAppWidthClass(true);

  return (
    <Box className={classes.root}>
      <Box className={classNames(classes.content, widthClass)}>
        <Box
          className={classNames(
            isDesktopWidth && classes.wrapperDesktop,
            isTabletWidth && classes.wrapperTablet,
            isMobileWidth && classes.wrapperMobile
          )}
        >
          {isDesktopWidth && <Welcome className={classes.welcomeDesktop} />}
          {isTabletWidth && <WelcomeTitle isTabletWidth />}
          <Box
            className={classNames(
              isDesktopWidth && classes.contentDesktop,
              isTabletWidth && classes.contentTablet
            )}
          >
            {children}
          </Box>
          {isTabletWidth && <WelcomeDescription isTabletWidth />}
        </Box>
      </Box>
    </Box>
  );
};

export default LoginLayout;
